import { TableProps } from 'antd';
import { round, uniqueId } from 'lodash';

import {
  CONVERSION_FROM_FIRST,
  CONVERSION_FROM_PREVIOUS,
} from '@src/emp-3.0/components/Sankey/utils/constants';
import { IFunnel } from '@src/emp-3.0/types';

export const transformFunnelDataToTableData = (funnelRes: {
  event_names: string[];
  funnel_data: IFunnel[];
}) => {
  const { event_names, funnel_data } = funnelRes;

  const columnWidth = `${100 / event_names.length}%`;

  return event_names.reduce(
    (
      previousValue: {
        columns: TableProps<any>['columns'];
        dataSource: { [key: string]: string }[];
      },
      currentValue,
      currentIndex,
    ) => {
      const dataIndex = `${currentValue}_${currentIndex}`;
      previousValue.columns?.push({
        key: uniqueId(currentValue),
        title: currentValue,
        dataIndex: dataIndex,
        width: columnWidth,
      });
      const step = funnel_data[0][`step_${currentIndex + 1}`];
      const conversion_from_first = step[CONVERSION_FROM_FIRST] // undefined 0 0~1
        ? round(step[CONVERSION_FROM_FIRST] * 100, 2) + '%'
        : step[CONVERSION_FROM_FIRST] === 0
        ? '0%'
        : '100%';
      const conversion_from_previous = step[CONVERSION_FROM_PREVIOUS]
        ? round(step[CONVERSION_FROM_PREVIOUS] * 100, 2) + '%'
        : step[CONVERSION_FROM_FIRST] === 0
        ? '0%'
        : '-';
      previousValue.dataSource[0][dataIndex] = conversion_from_first;
      previousValue.dataSource[1][dataIndex] = conversion_from_previous;
      return previousValue;
    },
    {
      columns: [{ dataIndex: 'key', width: 160, ellipsis: true }],
      dataSource: [{ key: '% of first step' }, { key: '% of pre step' }],
    },
  );
};
